import { render, staticRenderFns } from "./OutstandingTickets.vue?vue&type=template&id=31cce2f6&"
import script from "./OutstandingTickets.vue?vue&type=script&lang=js&"
export * from "./OutstandingTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports